export default __webpack_public_path__ + "static/O0121-adbd24c44e3fa6614d10a9237b14dc53.png";